module.exports = __webpack_public_path__ + "static/assets/7f848e761c790803ece92402ddc4a8d7.gif";